import React from "react";
import { Link } from "react-router-dom";
import { footerlogo, logo } from "../Constant/Index";

function Footer() {
  return (
    <>
      {/* Footer Section  */}
      <div className="footer-start secondary-color">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 mb-md-0 mb-5">
              <figure className="footer-logo">
                <div className="footer-logo-wrapper wow animate__animated animate__zoomIn">
                  <Link href="" className="d-block w-fit">
                    <img
                      src={footerlogo}
                      class="img-fluid light-image"
                      alt=""
                    />
                  </Link>
                </div>
              </figure>
            </div>
            <div className="col-lg-9 ms-auto ">
              <div className="head-input">
                <div className="footer-lists mb-4">
                  <h4 className="level-6 bold-font body-color text-uppercase">
                    Follow Us & Subscribe
                  </h4>
                </div>
                <div className="footer-search">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Email"
                  />
                  <div className="send-btn-search">
                    <Link
                      href=""
                      className="send-btn level-10 secondary-medium-font text-decoration-none"
                    >
                      Send
                    </Link>
                  </div>
                  <div className="footer-ul pt-3">
                    {/* <h5 className="level-7 bold-font body-color text-uppercase">
                      Follow US
                    </h5> */}
                    <ul>
                      <li>
                        <Link to="/">
                          <i class="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="/">
                          {" "}
                          <i class="fa-brands fa-instagram"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="/">
                          {" "}
                          <i class="fa-brands fa-x-twitter"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="footer-brands">
                  <ul>
                    <li>
                      <Link></Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* <div class="social-here d-flex align-items-center gap-3 mt-4">
                <ul class=" list-unstyled d-flex ps-0 mb-0 gap-1">
                  <Link
                    href="https://www.facebook.com/"
                    class="icon-badge md link-hover"
                  >
                    <i class="fa-brands fa-facebook-f"></i>
                  </Link>
                  <Link
                    href="https://twitter.com/"
                    class="icon-badge md link-hover"
                  >
                    <i class="fa-brands fa-x-twitter"></i>
                  </Link>
                  <Link
                    href="https://pk.linkedin.com/"
                    class="icon-badge md link-hover"
                  >
                    <i class="fa-brands fa-linkedin-in"></i>
                  </Link>
                  <Link
                    href="https://www.instagram.com/"
                    class="icon-badge md link-hover"
                  >
                    <i class="fa-brands fa-instagram"></i>
                  </Link>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
        <div className="footer-wrap pt-5 position-relative">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-6 col-6 border-right position-relative py-4">
                <div className="footer-lists-heading mb-4">
                  <h5 className="level-7 bold-font body-color text-uppercase">
                    About
                  </h5>
                  <p className="mt-5 level-10 secondary-medium-font body-color opacity-7">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-6 border-right position-relative d-md-flex flex-column justify-content-center align-items-center py-4">
                <div className="footer-lists-heading mb-4">
                  <h5 className="level-7 bold-font body-color text-uppercase">
                    Products
                  </h5>
                </div>
                <div className="footer-lists">
                  <ul className="footer-links p-0">
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Candles
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Incense{" "}
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="./shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Books
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Perfumes
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Statues
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Mojo Bags
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/delivery-page"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Delivery Page
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-6 border-right position-relative d-md-flex flex-column justify-content-center align-items-center py-4">
                <div className="footer-lists-heading mb-4">
                  <h5 className="level-7 bold-font body-color text-uppercase">
                    Quick Links
                  </h5>
                </div>
                <div className="footer-lists">
                  <ul className="footer-links p-0">
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="./"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Home
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/about-us"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . About us{" "}
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Shop
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="Blogs"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Blogs
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/shop"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Stores
                      </Link>
                    </li>
                    <li className="single-items mb-2 d-flex gap-2 align-items-center">
                      <Link
                        to="/contact-us"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover opacity-7"
                      >
                        . Contact us{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-6 d-md-flex flex-column py-4 px-md-5">
                <div className="footer-lists-heading mb-4">
                  <h5 className="level-7 bold-font body-color text-uppercase">
                    Contact us
                  </h5>
                </div>
                <div className="footer-lists">
                  <ul className="footer-links p-0">
                    <li className="single-items mb-3 d-flex gap-2 align-items-center ">
                      <Link
                        to="#"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover d-flex gap-3"
                      >
                        <span className="icon-span">
                          <svg
                            width="19"
                            height="20"
                            viewBox="0 0 19 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.0153 0.682617C13.1726 0.682617 11.6786 2.17661 11.6786 4.01928C11.6786 5.73934 13.4155 8.01769 14.3831 9.15299C14.7159 9.54338 15.3146 9.54338 15.6474 9.15299C16.6142 8.01769 18.3519 5.73934 18.3519 4.01928C18.3519 2.17661 16.8579 0.682617 15.0153 0.682617ZM8.34192 2.35095C5.6217 2.35095 3.2089 3.66643 1.68488 5.68762H1.66859V5.7088C0.35811 7.45888 -0.293922 9.729 0.127332 12.1589C0.713751 15.5415 3.40926 18.2786 6.78763 18.8925C12.0671 19.851 16.6836 15.8011 16.6836 10.6926C16.6836 10.6342 16.6763 10.5775 16.6754 10.5199C16.4777 10.7418 16.3144 10.9159 16.216 11.0168L14.7497 12.5418C14.4611 13.5403 13.9413 14.4394 13.2589 15.1877C13.0429 14.517 12.421 14.0293 11.6786 14.0293H10.8444V12.361C10.8444 11.4392 10.0978 10.6926 9.17609 10.6926H6.67359C6.21313 10.6926 5.83942 10.3189 5.83942 9.85845C5.83942 9.39799 6.21313 9.02428 6.67359 9.02428C7.13405 9.02428 7.50775 8.65058 7.50775 8.19012V7.35595C7.50775 6.89549 7.88146 6.52178 8.34192 6.52178H9.17609C9.66741 6.52178 10.1057 6.30568 10.411 5.96784C10.1675 5.31636 10.0103 4.65492 10.0103 4.01928C10.0103 3.51628 10.086 3.03211 10.2253 2.57416C9.61887 2.43318 8.99007 2.35095 8.34192 2.35095ZM15.0153 2.82669C15.6734 2.82669 16.2078 3.36113 16.2078 4.01928C16.2078 4.67744 15.6734 5.21188 15.0153 5.21188C14.3571 5.21188 13.8227 4.67744 13.8227 4.01928C13.8227 3.36113 14.3571 2.82669 15.0153 2.82669ZM1.84454 9.20024L3.33692 10.6926L5.83942 13.1951V14.0293C5.83942 14.951 6.586 15.6976 7.50775 15.6976V17.3089C4.22114 16.896 1.66859 14.0893 1.66859 10.6926C1.66859 10.1788 1.7336 9.68072 1.84454 9.20024Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                        <span className="icon-span-text">
                          Lorem ipsum dolor sit amet, consectetur adip.
                        </span>
                      </Link>
                    </li>
                    <li className="single-items mb-3 d-flex gap-2 align-items-center ">
                      <Link
                        to="tel:+111 - 222 - 333"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover d-flex gap-3"
                      >
                        <span className="icon-span">
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 13 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.15146 3.02446C5.13333 2.662 5.03819 2.31766 4.86602 1.99145C4.69385 1.66523 4.51262 1.39792 4.32233 1.18951C4.13204 0.981092 3.91909 0.790801 3.6835 0.618632C3.4479 0.446465 3.28026 0.328665 3.18058 0.265234C3.08091 0.201804 2.99482 0.161027 2.92233 0.142904C2.83172 0.106658 2.75016 0.0975971 2.67767 0.11572C2.24272 0.188211 1.85307 0.296949 1.50874 0.441934C1.1644 0.586917 0.906149 0.731901 0.733981 0.876884C0.561812 1.02187 0.412298 1.18044 0.285437 1.35261C0.158576 1.52478 0.0815534 1.64258 0.0543689 1.70601C0.0271845 1.76944 0.0135922 1.82834 0.0135922 1.88271C-0.00453074 1.9552 -0.00453074 2.03676 0.0135922 2.12737C0.394175 3.28724 0.847249 4.36556 1.37282 5.36232C1.89838 6.35909 2.41489 7.19274 2.92233 7.86329C3.42977 8.53384 4.00971 9.15002 4.66214 9.71184C5.31456 10.2736 5.87638 10.7086 6.34757 11.0167C6.81877 11.3248 7.35793 11.6147 7.96505 11.8866C8.57217 12.1584 9.01618 12.3397 9.29709 12.4303C9.57799 12.5209 9.92686 12.6206 10.3437 12.7293C10.5249 12.7837 10.6427 12.8199 10.6971 12.838C10.7333 12.8562 10.7786 12.8652 10.833 12.8652C10.8874 12.8652 10.9417 12.8471 10.9961 12.8109C11.0505 12.7927 11.1139 12.761 11.1864 12.7157C11.2589 12.6704 11.3812 12.5753 11.5534 12.4303C11.7256 12.2853 11.8796 12.1177 12.0155 11.9274C12.1515 11.7371 12.2919 11.4788 12.4369 11.1526C12.5819 10.8264 12.6906 10.4639 12.7631 10.0652C12.7631 9.97462 12.745 9.884 12.7087 9.79339C12.6906 9.75714 12.6589 9.70277 12.6136 9.63028C12.5683 9.55779 12.4686 9.43546 12.3146 9.26329C12.1605 9.09112 11.9883 8.92802 11.7981 8.77397C11.6078 8.61993 11.354 8.46135 11.0369 8.29824C10.7197 8.13514 10.3799 8.00828 10.0175 7.91766C9.87249 7.88142 9.73657 7.9086 9.60971 7.99922C8.79418 8.70601 8.17799 9.09566 7.76117 9.16815C6.69191 8.64258 5.78576 7.93578 5.04272 7.04776C4.29968 6.15973 3.90097 5.53449 3.8466 5.17203C3.8466 5.06329 3.9644 4.82316 4.2 4.45164C4.4356 4.08012 4.71651 3.71313 5.04272 3.35067C5.13333 3.26006 5.16958 3.15132 5.15146 3.02446Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                        <span className="icon-span-text">+111 - 222 - 333</span>
                      </Link>
                    </li>
                    <li className="single-items mb-3 d-flex gap-2 align-items-center ">
                      <Link
                        to="mailto:Powerfulhand@outlook.com"
                        className="level-10 secondary-medium-font body-color text-decoration-none link-hover d-flex gap-3"
                      >
                        <span className="icon-span">
                          <svg
                            width="16"
                            height="14"
                            viewBox="0 0 16 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.59485 0.492188C0.853244 0.492188 0.233097 1.00486 0.0560689 1.69144L7.97424 6.65354L15.8971 1.70546C15.7248 1.0109 15.1008 0.492188 14.3536 0.492188H1.59485ZM0 3.47007V11.6561C0 12.5357 0.71529 13.251 1.59485 13.251H14.3536C15.2332 13.251 15.9485 12.5357 15.9485 11.6561V3.4872L7.97424 8.46643L0 3.47007Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                        <span className="icon-span-text">
                          Powerfulhand@outlook.com
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom text-start pt-3 pb-3">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <p className="level-9 secondary-medium-font body-color mb-0 opacity-7">
                  © Powerfulhand 2024 | All Rights Reserved
                </p>
              </div>
              <div className="col-md-6">
                <div className="my-footer-terms text-right">
                  <Link
                    to="/terms-condition"
                    className="level-9 secondary-medium-font body-color mb-0 opacity-7 "
                  >
                    Terms & Conditions
                  </Link>
                  <Link
                    to="/shipping-policy"
                    className="level-9 secondary-medium-font body-color mb-0 opacity-7 ml-3 "
                  >
                    Shipping Policy
                  </Link>
                  <Link
                    to="/privacy-policy"
                    className="level-9 secondary-medium-font body-color mb-0 opacity-7 ml-3"
                  >
                    Privacy Policy
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
